import React, {useEffect} from 'react';

import { useLocation } from "react-router-dom";

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormHelperText from '@mui/material/FormHelperText';

import Typography  from '@mui/material/Typography';
import Button  from '@mui/material/Button';

import axios from "axios";

function LoginPage(props){

  const location = useLocation();
  const { url } = location.state || {};
  if (url) window.location.href = url;
  
  return (
  <>  </>
  );
}

export default LoginPage;
